import React from "react";
import Layout from "components/Layout";
import GroupEditForm from "./Components/GroupEditForm";

function AdminGroupEditPage() {
  return (
    <Layout title=" 그룹 수정/삭제">
      <GroupEditForm />
    </Layout>
  );
}

export default AdminGroupEditPage;
